import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import * as parentConstants from 'modules/project/ProjectAreaPage/constants';
import { Permission } from 'providers/authorisation';
import { partial } from 'ramda';
import { i18n } from '@lingui/core';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import { NewPourPageParams } from './constants';
import useNewPourQueries, { NewPourQueries } from './useNewPourQueries';

const NewPourPage = lazyWithSuspense(() => import('./NewPourPage'));

const page: Page<constants.NewPourPageParams> = {
  title: i18n._(constants.TITLE),
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: partial(context.functions.validatePermission, [Permission.ManagePours]),
    teamId: typeof params.projectId === 'string' ? params.projectId : '',
  }),
  component: withLicenceAndDisclaimer({
    pageDataHook: useNewPourQueries,
    Component: makePage<NewPourPageParams, [], NewPourQueries>({
      WrappedPage: NewPourPage,
      titleFn: () => i18n._(constants.TITLE),
      parentPathTemplate: `${parentConstants.STOPES_ROUTE_PATH}`,
      parentTitleFn: () => i18n._('Recipes'),
    }),
  }),
};

export default page;
